import React from 'react';
import { FormLabel, useColorModeValue } from '@chakra-ui/react';

// item 254a/261c — the shared form-field label. Legible in both skins, and reserves a
// consistent (up to 2-line) height with its text bottom-aligned, so a long wrapping
// label ("Customer Project Manager") keeps its input on the same row baseline as a
// neighbouring one-line field instead of dropping below it.
const FieldLabel: React.FC<{ htmlFor?: string }> = ({ htmlFor, children }) => {
  const color = useColorModeValue('gray.700', 'whiteAlpha.900');
  return (
    <FormLabel
      fontSize="sm"
      color={color}
      htmlFor={htmlFor}
      mb={1}
      minH={{ md: '2.4em' }}
      lineHeight="1.2"
      display="flex"
      alignItems="flex-end"
    >
      {children}
    </FormLabel>
  );
};

FieldLabel.defaultProps = {
  htmlFor: undefined,
};

export default FieldLabel;
